(ns app.front.acceptance.components
  (:require [app.domain.util :as du]
            [app.front.acceptance.events :as acceptance-evt]
            [app.front.ui :as ui]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.rich-text :as ui-rt]
            [app.front.ui.status :as ui-status]
            [app.front.util :as futil]
            [app.front.view.conversations.core :as conversations]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [>evt <sub]]
            [core.front.icons :as i]
            [core.user.model :as user-model]
            [core.util.util :as util]
            [reagent.core :as r]))


(defmulti render-acceptance {:arglists '([tr entity-type acceptance])}
  (fn [_ entity-type _] entity-type))

(defmethod render-acceptance :default
  [tr _entity-type acceptance]
  (let [recipient-id (-> acceptance :entity/creator :db/id)]
    [:div.flex.bg-grey-tint-20.text-gray68.border-l-4.border-solid.p-4.rounded
     {:class (case (:acceptance/value acceptance)
               :acceptance.value/ok            (ui-status/status->border-color-class :ok)
               :acceptance.value/needs-changes (ui-status/status->border-color-class :critical)
               (ui-status/status->border-color-class :task))}
     [:div.flex.flex-col
      [:div
       ((<sub [::date-util/date-time-fn]) (:entity/created acceptance))]
      [:div.mt-4
       [user-model/full-name (:entity/creator acceptance)]]
      (when (du/in-state? :acceptance.state/draft acceptance)
        [:div [ui/tag {:type :round :color :blue :class-name "uppercase"} (tr [:review/draft])]])

      [:div
       (cc/link
         {:on-click   #(>evt [::conversations/open-overlay-for-direct-msg recipient-id acceptance])
          :class-name "cursor-pointer"}
         (tr [:review/direct-message])
         (cc/icon {:icon        i/conversation
                   :description ""
                   :class-name  "ml-1"}))]]
     [:div.flex-1.flex-col.ml-4
      [:div.font-semibold.flex (when-let [value (:acceptance/value acceptance)] (tr [value]))]
      (when-some [text (not-empty (:acceptance/text acceptance))]
        [:div.mt-2
         [ui-rt/editor-legacy {:initial-value text
                               :id            (str (:db/id acceptance) "-text-display")}]])]]))

(defn modal-acceptance-submit [tr target value]
  (r/with-let [*modal-open      (r/atom false)
               *acceptance-text (r/atom "")]
    (let [acceptance-text @*acceptance-text
          review-id       (<sub [::acceptance-evt/review-id-for-new-acceptance (:db/id target)])
          do-create       #(>evt [::acceptance-evt/create
                                  (-> target :entity/parent :db/id)
                                  (:db/id target)
                                  value
                                  acceptance-text
                                  review-id])
          close-modal     (fn [& _]
                            (reset! *modal-open false)
                            (reset! *acceptance-text "")
                            true)]
      [:div
       [ui/button
        {:kind             :secondary
         :icon             i/circle-info
         :icon-description (tr [value])
         :on-click         #(swap! *modal-open not)}
        (tr [value])]
       [ui-modal/composed-input-modal
        {:open                   @*modal-open
         :on-key-down            (fn [e]
                                   (when (and (= "Enter" (-> e .-key))
                                              (or (-> e .-metaKey) (-> e .-ctrlKey)))
                                     (do-create)
                                     (close-modal)))
         :key                    (str (:db/id target) "-acceptance-modal")
         :selector-primary-focus "textarea"
         :class-name             "text-left"
         :on-close               close-modal}
        [cc/modal-header
         (util/mmap {:title (tr [value])}
                    close-modal)]
        [cc/modal-body {}
         [ui/text-area
          {:id          (str (:db/id target) "-acceptance-modal-textarea")
           :data-cy     "acceptance-modal-textarea"
           :label-text  (tr [:acceptance/request-text-field-title])
           :helper-text (tr [:acceptance/request-text-field-help])
           :value       acceptance-text
           :on-change   #(reset! *acceptance-text (futil/tval %))
           :placeholder (tr [:acceptance/request-text-field-placeholder])}]]
        [cc/modal-footer {}
         [cc/button
          {:kind     :tertiary
           :on-click close-modal}
          (tr [:cancel])]
         [cc/button
          {:kind     :primary
           :data-cy  "save-btn"
           :on-click (fn [_]
                       (do-create)
                       (close-modal))}
          (tr [:save])]]]])))


(defn create-acceptance-button
  [tr target value] ;; TODO TODO process target / target id separate
  (if (= value :acceptance.value/needs-changes)
    [modal-acceptance-submit tr target value]
    (let [ok?       (= :acceptance.value/ok value)
          review-id (<sub [::acceptance-evt/review-id-for-new-acceptance (:db/id target)])]
      [ui/button {:kind             (if ok? :primary :secondary)
                  :icon             (if ok? i/check i/circle-info)
                  :on-click         #(>evt [::acceptance-evt/create
                                            (-> target :entity/parent :db/id)
                                            (:db/id target)
                                            value
                                            nil
                                            review-id])
                  :icon-description (tr [:approve-target]
                                        [(str/lower-case (tr [(:entity/type target)]))])}
       (tr [value])])))


(defn acceptance-changes-made-button
  [{:keys [tr acceptance-id process-target-id pending-left? button-kind]}]
  [ui/modal-confirmation-button
   {:trigger-button-opts {:kind             (or button-kind :ghost)
                          :icon             i/check
                          :icon-description (tr [:acceptance/changes-made])}
    :trigger-button-text (tr [:acceptance/changes-made])
    :id                  "acceptance-changes"
    :tr                  tr
    :modal-title         (tr [:acceptance/changes-made])
    :on-yes-click        #(>evt [::acceptance-evt/update-customer-value
                                 process-target-id
                                 acceptance-id
                                 :acceptance.customer-value/updated-by-customer])}
   (tr [(if pending-left?
          :acceptance/changes-made-confirmation-no-locking
          :acceptance/changes-made-confirmation)])])
